import { MEDIA } from "@bridgesplit/ui";

export const LOOP_DETAIL_QUERY = MEDIA.LG;
